import {useState, useEffect, useImperativeHandle, forwardRef} from 'react';

export default forwardRef((props, ref) => {
  const [filterState, setFilterState] = useState('off');

  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        const field = props.colDef.field;
        if (field == 'caseStatus') {
          let filter_abbrev = filterState == 'Closed' ? 'Closed' : 'Open';
          return params.data[field].toLowerCase() == filter_abbrev.toLowerCase();
        } else {
          // Certain DB tables contain whitespace-surrounded region names
          return params.data[field].toLowerCase().trim() == filterState.toLowerCase();
        }
      },

      isFilterActive() {
        return filterState !== 'off';
      },
      getModel() {
        if (filterState == 'off') {
          return undefined;
        }
        return {
          state: filterState,
        };
      },
      setModel(model) {
        if (!model) {
          setFilterState('off');
        } else {
          setValue(model.state);
        }
      },
      setValue(value) {
        return setFilterState(value);
      },
      getModelAsString() {
        return filterState == 'off' ? '' : filterState;
      },
    };
  });

  useEffect(() => {
    props.filterChangedCallback();
  }, [filterState]);

  return <></>;
});
